import { z } from 'zod';
// Zod schemas for validation
/**
 * Custom Zod schema for Timestamp validation
 */
const TimestampSchema = z.object({
    seconds: z.number(),
    nanoseconds: z.number(),
    toDate: z.function(),
    toMillis: z.function(),
});
/**
 * Schema for validating complete comment data
 */
export const CommentSchema = z.object({
    id: z.string().min(1),
    submissionId: z.string().min(1),
    fieldPath: z.string().min(1),
    authorId: z.string().min(1),
    authorName: z.string().min(1),
    content: z.string().min(1),
    resolved: z.boolean(),
    resolvedBy: z.string().min(1).optional(),
    resolvedAt: TimestampSchema.optional(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
/**
 * Schema for validating comment creation data
 */
export const CreateCommentDataSchema = z.object({
    submissionId: z.string().min(1),
    fieldPath: z.string().min(1),
    authorId: z.string().min(1),
    authorName: z.string().min(1),
    content: z.string().min(1),
});
/**
 * Schema for validating comment update data
 */
export const UpdateCommentDataSchema = z.object({
    content: z.string().min(1).optional(),
    resolved: z.boolean().optional(),
    resolvedBy: z.string().min(1).optional(),
    resolvedAt: TimestampSchema.optional(),
});
/**
 * Schema for validating comment summary data
 */
export const CommentSummarySchema = z.object({
    id: z.string().min(1),
    fieldPath: z.string().min(1),
    authorName: z.string().min(1),
    content: z.string().min(1),
    resolved: z.boolean(),
    createdAt: TimestampSchema,
});
/**
 * Schema for validating comment thread data
 */
export const CommentThreadSchema = z.object({
    fieldPath: z.string().min(1),
    comments: z.array(CommentSchema),
    unresolvedCount: z.number().min(0),
    lastCommentAt: TimestampSchema,
});
/**
 * Schema for validating comment statistics
 */
export const CommentStatsSchema = z.object({
    totalComments: z.number().min(0),
    unresolvedComments: z.number().min(0),
    resolvedComments: z.number().min(0),
    fieldsWithComments: z.number().min(0),
    lastCommentAt: TimestampSchema.optional(),
});
/**
 * Type guards for comment data
 */
export const isValidComment = (data) => {
    return CommentSchema.safeParse(data).success;
};
export const isValidCreateCommentData = (data) => {
    return CreateCommentDataSchema.safeParse(data).success;
};
export const isValidUpdateCommentData = (data) => {
    return UpdateCommentDataSchema.safeParse(data).success;
};
export const isValidCommentSummary = (data) => {
    return CommentSummarySchema.safeParse(data).success;
};
export const isValidCommentThread = (data) => {
    return CommentThreadSchema.safeParse(data).success;
};
export const isValidCommentStats = (data) => {
    return CommentStatsSchema.safeParse(data).success;
};
